export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || "2024-01-08";

const rawDataset = process.env.NEXT_PUBLIC_SANITY_DATASET || "production";
export const dataset = rawDataset
  .replace(/^["'""']+|["'""']+$/g, '')
  .trim();

export const token =
  process.env.SANITY_API_READ_TOKEN ||
  process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN ||
  "";

if (!token) {
  throw new Error(
    "A secret is provided but there is no `NEXT_PUBLIC_SANITY_API_READ_TOKEN` environment variable setup. " +
      process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN,
  );
}

const rawProjectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || "";

// Validate and clean projectId (remove quotes, whitespace, and smart quotes)
export const projectId = rawProjectId
  .replace(/^["'""']+|["'""']+$/g, '') // Remove surrounding quotes (regular, smart, single)
  .trim(); // Remove whitespace

// Validate projectId format
if (!/^[a-z0-9-]+$/.test(projectId)) {
  console.error('Invalid projectId detected:', {
    raw: rawProjectId,
    cleaned: projectId,
    env: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID
  });
  throw new Error(`Invalid NEXT_PUBLIC_SANITY_PROJECT_ID format: "${projectId}". Must contain only lowercase letters, numbers, and dashes.`);
}

export const useCdn = false;

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}

export const STUDIO_ORIGIN =
  process.env.NODE_ENV !== "production"
    ? process.env.NEXT_PUBLIC_STUDIO_ORIGIN || "/studio"
    : process.env.NEXT_PUBLIC_STUDIO_ORIGIN || "/studio";

export const domain =
  process.env.NEXT_PUBLIC_DOMAIN || "www.placeholder.com";

function normalizeDomain(domain: string): string {
  // Remove protocol if present
  const cleanDomain = domain.replace(/^https?:\/\//, "").replace(/\/$/, "");

  // Map actual domains to schema values
  if (cleanDomain === "placeholder" || cleanDomain === "www.placeholder") {
    return "main";
  }
  if (cleanDomain === "get.placeholder") {
    return "lp";
  }

  // Default fallback for localhost and other development domains
  return "main";
}

export const normalizedDomain = normalizeDomain(domain);
